import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { HOVER, MOUSE_ENTER, MOUSE_LEAVE, HIDDEN } from '../../constants';
import { hasChildren } from '../../helpers';
import BlazeLink from '../BlazeLink';
import MenuContext from '../Menu/MenuContext';

const MenuItem = ({ children, eventType, text, modifier, url }) => {
  const [displayChildren, setDisplayChildren] = useState(false);
  const { showMobileMenu } = useContext(MenuContext);

  useEffect(
    () => {
      if (!showMobileMenu) setDisplayChildren(false);
    },
    [showMobileMenu]
  );

  const isHoverEvent = eventType === HOVER;
  const childrenDisplayClass = displayChildren ? '' : HIDDEN;

  const handleItemEvent = ({ type }) => {
    if (isHoverEvent) {
      if (type === MOUSE_ENTER) {
        setDisplayChildren(true);
      }
      if (type === MOUSE_LEAVE) {
        setDisplayChildren(false);
      }
    }
  };
  const hasValidChildren = hasChildren(children);

  return (
    <li
      className={modifier}
      onMouseEnter={handleItemEvent}
      onMouseLeave={handleItemEvent}
      aria-label={text}>
      <div className="menu--item--link">
        {url ? (
          <BlazeLink href={url}>{text}</BlazeLink>
        ) : (
          <span role="button" onClick={handleItemEvent} aria-label={text}>
            {text}
          </span>
        )}
        {hasValidChildren && (
          <i
            role="button"
            aria-label={
              displayChildren ? `Collapse ${text} menu items` : `Expand ${text} menu items`
            }
            className="menu--item--link--icon"
            onClick={() => setDisplayChildren(!displayChildren)}>
            {displayChildren ? <FaChevronUp /> : <FaChevronDown />}
          </i>
        )}
      </div>
      {hasValidChildren && (
        <div className={`menu--item-children ${childrenDisplayClass}`}>{children}</div>
      )}
    </li>
  );
};

MenuItem.propTypes = {
  modifier: PropTypes.string,
  text: PropTypes.string,
  url: PropTypes.string,
  eventType: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

MenuItem.defaultProps = {
  url: '',
  modifier: '',
  text: '',
  children: null
};

export default MenuItem;
